const packageUserType = {
	consumer:"CONSUMER",
	provider:"PROVIDER",
	contributor:"CONTRIBUTOR"
}

export default packageUserType
